import React from "react"
import connect from "react-redux/es/connect/connect"
import {withStyles, Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Link, Collapse, IconButton} from "@material-ui/core"
import baseStyles from './style'
import { URL_HELP_CENTER } from 'redux/constants'
import InfoIcon from '@material-ui/icons/Info';
import DescriptionIcon from '@material-ui/icons/Description';
import BookIcon from '@material-ui/icons/Book';
import VideocamIcon from '@material-ui/icons/Videocam';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import LaunchIcon from '@material-ui/icons/Launch';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = theme => Object.assign({}, (typeof baseStyles === 'function' ? baseStyles(theme) : baseStyles), {
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit * 1,
  },
  icon: {
    marginRight: theme.spacing.unit * 1,
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  listText: {
    paddingTop: '13px',
    paddingBottom: '13px',
  }
})

class HelpCenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = { howtoOpen: false }
  }

  toggleHowto = () => this.setState(s => ({ howtoOpen: !s.howtoOpen }))

  render() {
    const { classes } = this.props

    const links = [
      { label: 'Admin User Manual', url: 'https://schooltechnology.my.site.com/s/article/SchoolTRAK-Admin-User-Guide', icon: DescriptionIcon },
      { label: 'Staff User Manual', url: 'https://schooltechnology.my.site.com/s/article/SchoolTRAK-Staff-User-Guide', icon: DescriptionIcon },
      { label: 'Admin Portal Guide', url: 'https://schooltechnology.my.site.com/s/article/SchoolTRAK-Admin-Portal', icon: BookIcon },
      { label: 'Implementation Guide', url: 'https://schooltechnology.my.site.com/s/article/SchoolTRAK-Implementation-Guide', icon: BookIcon },
      { label: 'Demo Video', url: 'https://www.youtube.com/watch?v=SWjLn0EqrFE', icon: VideocamIcon },
      { label: 'How-to Playlist', url: 'https://youtube.com/playlist?list=PLEVBwDsfoxpowTH6JdLE_7fE55i0VA4IY&si=jEC8gpgSId5OgCBn', icon: PlaylistPlayIcon },
    ]

    const adminHowtos = [
      { label: 'SchoolTRAK Admin Panel: Homepage / Support Overview', url: 'https://youtu.be/aE4D_OuXRoo?si=Co0f_3InsOfK99l9' },
      { label: 'SchoolTRAK Admin Panel: Users Overview', url: 'https://youtu.be/kV6P0KhV8Xw?si=wjYt7kLMrv0_H_jH' },
      { label: 'SchoolTRAK Admin Panel: Period Rules Overview', url: 'https://youtu.be/stjePtOSnXY?si=drtkwwr1dbjhoK3h' },
      { label: 'SchoolTRAK Admin Panel: Settings Overview', url: 'https://youtu.be/WbvHs0IwhkI?si=Qonsw6Osk0Bufp-9' },
      { label: 'SchoolTRAK Admin Panel: Semester Rules Overview', url: 'https://youtu.be/JB6ovAhsX2Q?si=ubpTBO8xdCbTUsvD' },
      { label: 'SchoolTRAK Admin Panel Student Search and Details Overview', url: 'https://youtu.be/TBRALiUwz5s?si=h0M_0vfUKPPSlRRX' },
      { label: 'SchoolTRAK Admin Panel: Student Locator Overview', url: 'https://youtu.be/RaFY7pkGGEs?si=uX4GNmi6aglAIMXL' },
      { label: 'SchoolTRAK Admin Panel: Reports Overview', url: 'https://youtu.be/VtWlj_Uwgcw?si=xr6DToZy9sqJCwve' },
      { label: 'SchoolTRAK Admin Panel: Locations Overview', url: 'https://youtu.be/WICBNCp_3yI?si=9F5mId9K-dQ3NnV2' },
      { label: 'SchoolTRAK Admin Panel: Buildings Overview', url: 'https://youtu.be/Ra1Yesi5HfI?si=NKbOm9G4TbHJpAPz' },
      { label: 'SchoolTRAK Admin Panel: Messaging Overview', url: 'https://youtu.be/ZZm3jaqJp_8?si=xEF3U3FhF-esYJNR' },
    ]

    const kioskHowtos = [
      { label: 'SchoolTRAK Kiosk: Configuration', url: 'https://youtu.be/oJrhBXoNNgM?si=dGNBqWNMncJYGAU4' },
    ]
    return (
      <div className={classes.root}>
        <Paper className={classes.paper} style={{maxWidth: 800}}>
          <div style={{ padding: 16 }}>
            <div className={classes.header}>
              <InfoIcon className={classes.icon} />
              <Typography variant="h5">Helpful resources and guides for SchoolTRAK</Typography>
            </div>

            <List>
              {links.map((l, idx) => (
                <React.Fragment key={idx}>
                  <ListItem className={classes.listItem}>
                    <ListItemIcon>
                      {React.createElement(l.icon)}
                    </ListItemIcon>
                    <ListItemText
                      primary={(
                        <Link href={l.url} target="_blank" rel="noopener noreferrer" color="primary">
                          {l.label}
                        </Link>
                      )}
                    />
                    {l.label === 'How-to Playlist' ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton onClick={this.toggleHowto} aria-label={this.state.howtoOpen ? 'Collapse' : 'Expand'}>
                          <ExpandMoreIcon style={{ transform: this.state.howtoOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                        </IconButton>
                        <ListItemIcon>
                          <Link href={l.url} target="_blank" rel="noopener noreferrer" color="primary" aria-label={`${l.label} (opens in new tab)`}>
                            <LaunchIcon />
                          </Link>
                        </ListItemIcon>
                      </div>
                    ) : (
                      <ListItemIcon>
                        <Link href={l.url} target="_blank" rel="noopener noreferrer" color="primary" aria-label={`${l.label} (opens in new tab)`}>
                          <LaunchIcon />
                        </Link>
                      </ListItemIcon>
                    )}
                  </ListItem>

                  {l.label === 'How-to Playlist' ? (
                    <Collapse in={this.state.howtoOpen} timeout="auto" unmountOnExit>
                      <div style={{ paddingLeft: 48 }}>
                        <Typography variant="subtitle2" style={{ marginTop: 8 }}>Admin</Typography>
                        <List disablePadding>
                          {adminHowtos.map((s, i) => (
                            <ListItem key={`admin-${i}`} className={classes.listItem} dense>
                              <ListItemText primary={(
                                <Link href={s.url} target="_blank" rel="noopener noreferrer" color="primary">
                                  {s.label}
                                </Link>
                              )} />
                            </ListItem>
                          ))}
                        </List>

                        <Typography variant="subtitle2" style={{ marginTop: 8 }}>Kiosk</Typography>
                        <List disablePadding>
                          {kioskHowtos.map((s, i) => (
                            <ListItem key={`kiosk-${i}`} className={classes.listItem} dense>
                              <ListItemText primary={(
                                <Link href={s.url} target="_blank" rel="noopener noreferrer" color="primary">
                                  {s.label}
                                </Link>
                              )} />
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </Collapse>
                  ) : null}
                </React.Fragment>
              ))}
            </List>
          </div>
        </Paper>
      </div>
    )
  }
}

const mapStateToProps = state => {

}

const mapDispatchToProps = {

}

export const HelpCenterPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(HelpCenter))

export const helpCenterPage = {
  icon: InfoIcon,
  component: HelpCenterPage,
  name: 'Help Center',
  displayName: 'Help Center',
  to: URL_HELP_CENTER
}

export default HelpCenterPage
